
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.md?watch=parent';
    export const demoIndex = {
  ids: ["line-demo-common","line-demo-markdown","line-demo-category"],
  getter: () => import(/* webpackChunkName: "meta__Line" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Line/index.md?type=demo')
};